"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTabber = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _pollux_dms = require("../../pollux_dms");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _log = require("../../service/logging/log.js");
var _Log = require("../../constants/Log.js");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook.js");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
* Description: This component allows creating a tabbing system
* Props:
* - tabs: List of tabs in the format below
* - selected: The initially selected tab, name or index (default: 0)
* - fill: If the tabs should fill the header (default: false)
* - justify: If the tabs should justify on header (default: false)
* - pills: If the tabs should use the pills format (default: false)
* - allowRemove: If the tabs can be removed, can be overridden by the tab itself (default: false)
* - onChange: Callback for selected tab changes (default: do nothing)
* - onRemove: Callback for removing a tab (default: hide the tab)
* - onLog: Callback for logging tab changes (default: do nothing)
* - pageName: Parent page name for audit trail logging (optional, used for log module context)
* - sxTabs: Custom styles applied to the Tabs component
* - sxTab: Custom styles applied to each individual Tab
* - sxContent: Custom styles applied to the content area

* Tabs format:
* const tabs = [
        {
            title: 'Tab 1 title',
            component: <Tab1Component/>,
            permissions: ['CAN_VIEW_TAB_1'], //Optional: This allows setting permissions for the tab
            keep: true // Optional: This prevents the tab from being removed if allowRemove = true
        },
        {
            title: 'Tab 2 title',
            component: <Tab2Component/>,
            hidden: true // Optional: This hides the tab
        },
  ]
*/
const DmsTabber = exports.DmsTabber = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  let {
    tabs,
    selected,
    fill,
    justify,
    pills,
    transition,
    allowRemove,
    onChange,
    onRemove,
    onLog,
    pageName,
    sxTabs,
    sxTab,
    sxContent
  } = props;
  tabs = tabs || [];
  selected = selected || 0;
  fill = fill || false;
  justify = justify || false;
  pills = pills || false;
  transition = transition !== undefined ? transition : true;
  allowRemove = allowRemove || false;
  onChange = onChange || function (key, item) {};
  onRemove = onRemove || function (key, item) {
    item.hidden = true;
  };
  onLog = onLog || function (old_key, new_key, by_user) {};
  pageName = pageName || null;
  const tabStyles = {
    default: {
      fontWeight: 'bold',
      color: '#1976d2',
      borderBottom: "1px solid",
      borderColor: 'divider'
    },
    active: {
      fontWeight: 'bold',
      borderTop: '1px solid ',
      borderRight: '1px solid ',
      borderLeft: '1px solid ',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderColor: 'divider'
    }
  };
  const id = (0, _pollux_dms.generate_random_id)();

  // Audit trail logging
  const token = (0, _DmsTokenHook.getToken)();
  const hasLoggedInitial = (0, _react.useRef)(false);
  const logTabAccess = tab => {
    if (!token || !tab) return;

    // Use tab.title for display message, tab.name for module identifier
    const message = _reactIntlUniversal.default.get("UserAccessedTabName").d("User accessed tab {name}").replace("{name}", tab.title);

    // Module uses tab.name (e.g., "SystemSettings/General")
    const module = pageName ? "".concat(pageName, "/").concat(tab.name) : tab.name;
    try {
      (0, _log.log)(message, module, _Log.LogLevel.INFO, _Log.LogType.USER, null, token);
    } catch (error) {
      console.error("Tab audit log error:", error);
    }
  };
  for (let index in tabs) {
    let tab = tabs[index];
    if (!tab.name) tab.name = tab.title.replace(' ', '');
  }
  if (typeof selected == 'number') {
    if (tabs.length > 0 && selected < tabs.length) selected = tabs[selected].name;
  }
  const getItem = key => {
    if (typeof key == 'number') {
      if (tabs.length > 0 && key < tabs.length) key = tabs[key].name;
    }
    for (let index in tabs) {
      if (tabs[index].name === key) return tabs[index];
    }
    return null;
  };
  const getIndex = key => {
    if (typeof key == 'number') {
      return key;
    }
    for (let index in tabs) {
      if (tabs[index].name === key) return index;
    }
    return 0;
  };
  const changeIndex = () => {
    let _index = null;
    for (let i = index; i < tabs.length; i++) {
      if (tabs[i].hidden) continue;
      _index = i;
      break;
    }
    if (_index == null) {
      for (let i = index; i >= 0; i--) {
        if (tabs[i].hidden) continue;
        _index = i;
        break;
      }
    }
    setIndex(_index);
    if (_index != null) {
      const item = getItem(_index);
      if (item != null) {
        setKey(item.name);
      }
    }
  };
  let _index = getIndex(selected);
  const [key, setKey] = (0, _react.useState)(selected);
  const [index, setIndex] = (0, _react.useState)(_index);

  // Log initial tab on mount
  (0, _react.useEffect)(() => {
    if (!hasLoggedInitial.current && tabs.length > 0 && token) {
      hasLoggedInitial.current = true;
      const initialTab = getItem(key);
      if (initialTab) {
        logTabAccess(initialTab);
      }
    }
  }, [token]);
  const select = new_key => {
    let old_key = key;
    setKey(new_key);
    const item = getItem(new_key);
    onChange(new_key, item);
    setIndex(getIndex(new_key));
    onLog(old_key, new_key, true);

    // Audit logging for tab change
    logTabAccess(item);
  };
  const remove = new_key => {
    let old_key = key;
    let item = getItem(new_key);
    if (item) {
      onRemove(new_key, item);
      onLog(old_key, new_key, false);
      setTimeout(() => {
        changeIndex();
      }, 50);
    }
  };
  if (ref) {
    ref.current = {
      select: select,
      current: key,
      index: index
    };
  }
  const tabRemoveStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
  };
  const getTitle = item => {
    if (allowRemove && !item.keep) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        sx: tabRemoveStyle
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, item.title), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        size: "small",
        onClick: () => remove(item.name),
        style: {
          marginLeft: '10px',
          padding: '0'
        }
      }, /*#__PURE__*/_react.default.createElement(_Close.default, {
        fontSize: "inherit"
      })));
    } else return /*#__PURE__*/_react.default.createElement(_material.Typography, null, item.title);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Tabs, {
    id: id,
    value: key,
    onChange: (e, newValue) => select(newValue),
    variant: fill ? 'fullWidth' : 'scrollable',
    scrollButtons: "auto",
    centered: justify,
    sx: _objectSpread({
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }, sxTabs)
  }, tabs.map(item => {
    if (item.hidden) return null;else {
      if (item.permissions && !(0, _DmsPermissions.havePermissions)(item.permissions, true)) return null;else return /*#__PURE__*/_react.default.createElement(_material.Tab, {
        key: item.name,
        value: item.name,
        label: getTitle(item),
        disabled: item.disabled,
        sx: _objectSpread(_objectSpread({}, key === item.name ? tabStyles.active : tabStyles.default), {}, {
          '&.Mui-selected': {
            color: 'black'
          }
        }, sxTab)
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Tab, {
    sx: {
      borderBottom: '1px solid',
      borderColor: 'divider',
      maxWidth: 'none',
      flex: 1
    },
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _objectSpread({
      paddingTop: '2rem'
    }, sxContent)
  }, tabs.map(item => {
    if (item.name === key) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        key: item.name
      }, item.component);
    }
    return null;
  })));
});